import {getBlobFromHub} from "../network/actions";

export const downloadExport = async function(exportUrl, fileName) {
    const blob = await getBlobFromHub(exportUrl);

    let url = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
};